module.exports = __webpack_public_path__ + "img/ch15_04_牵手回家.81383309.jpg";